import { useEffect, useReducer, useRef } from 'react';
import { GeoPoint } from '../firebase';
import { calculateDistance } from '../utils/component-utils/helpers';

const GET_RENTALS_BY_LOCATION = 'GET_RENTALS_BY_LOCATION';
const ON_ERROR = 'ON_ERROR';

function reducer(state, action) {
  switch (action.type) {
    case GET_RENTALS_BY_LOCATION: {
      const items = [...state.items];
      if (action.payload.snapshot && action.payload.userCoords) {
        action.payload.snapshot.forEach((doc) => {
          items.push({
            id: doc.id,
            distance: calculateDistance(
              action.payload.userCoords,
              doc.data().g.geopoint
            ),
            ...doc.data(),
          });
        });
      }
      return {
        ...state,
        loading: false,
        items,
      };
    }
    case ON_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

const defaultSettings = {
  enableHighAccuracy: false,
  timeout: Infinity,
  maximumAge: 0,
};

const initialState = {
  items: [],
  loading: true,
  error: null,
};

export const useRentalsByLocationQuery = (
  geoQuery,
  { settings = defaultSettings, limit = 30, radius = 500 } = {}
) => {

  const [state, dispatch] = useReducer(reducer, initialState);
  const persistedQuery = useRef(geoQuery);

  const onChange = async ({ coords }) => {
    const query = persistedQuery.current.near({
      center: new GeoPoint(coords.latitude, coords.longitude),
      radius: radius,
    }).limit(limit);
    const snapshot = await query.get();
    dispatch({
      type: GET_RENTALS_BY_LOCATION,
      payload: { snapshot, userCoords: coords },
    });
  };

  const onError = (err) => {
    dispatch({ type: ON_ERROR, error: err.message });
  };

  useEffect(() => {
    let isCancelled = false;
    if (!navigator || !navigator.geolocation) {
      dispatch({ type: ON_ERROR, error: 'Geolocation is not supported' });
      return;
    }
    if (!isCancelled)
      navigator.geolocation.getCurrentPosition(onChange, onError, settings);
    return () => (isCancelled = true);
    //eslint-disable-next-line
  }, [settings]);

  const { items, loading, error } = state;

  return { items, loading, error };
};
